/**
 * Eventos de conversión de Oscar Jaimes para el píxel personalizado (GA4).
 * Cualquier enlace o botón con data-oj-evento publica ese evento al hacer clic, con su origen
 * (data-oj-origen), la página y el destino. Se suscriben desde el píxel con analytics.subscribe().
 */

/**
 * @param {string} nombre
 * @param {Record<string, unknown>} datos
 */
function publicarEvento(nombre, datos) {
  try {
    window.Shopify?.analytics?.publish?.(nombre, datos);
  } catch {
    // La analítica nunca debe interrumpir la navegación.
  }
}

if (!window.ojEventosListos) {
  window.ojEventosListos = true;

  document.addEventListener(
    'click',
    (event) => {
      const objetivo = event.target instanceof Element ? event.target.closest('[data-oj-evento]') : null;
      if (!(objetivo instanceof HTMLElement)) return;

      const nombre = objetivo.dataset.ojEvento;
      if (!nombre) return;

      publicarEvento(nombre, {
        origen: objetivo.dataset.ojOrigen ?? '',
        pagina: window.location.pathname,
        destino: objetivo.getAttribute('href') ?? '',
      });
    },
    { capture: true }
  );
}
